/**
 * TASK-140 — typed confirmation gate for "Geheimnis rotieren". Rotating the
 * project's api_secret breaks the customer's live tracking script until it
 * is swapped everywhere, so the button stays disabled until the operator
 * types the exact project name (trimmed, so a stray copy-paste space/newline
 * doesn't block an otherwise-correct match — case still matters).
 */
export function matchesRotateConfirmation(input: string, projectName: string): boolean {
  return projectName.length > 0 && input.trim() === projectName;
}
